import type { PointAnnotationT, PointDataT } from '../../../types';
export function getTranslatedKeyPoint(deltaX: number, deltaY: number, keyPoint: PointAnnotationT, stageWidth?: number, stageHeight?: number) {
  let x = keyPoint.data.x + deltaX;
  let y = keyPoint.data.y + deltaY;

  // Constrain to stage bounds if dimensions provided
  if (stageWidth !== undefined && stageHeight !== undefined) {
    x = Math.max(0, Math.min(x, stageWidth));
    y = Math.max(0, Math.min(y, stageHeight));
  }
  return {
    ...keyPoint,
    data: {
      x,
      y
    }
  };
}
export const interpolateKeyPoint = (initialPoint: PointDataT, finalPoint: PointDataT, interpolationFactor: number): PointDataT => {
  return {
    x: initialPoint.x + (finalPoint.x - initialPoint.x) * interpolationFactor,
    y: initialPoint.y + (finalPoint.y - initialPoint.y) * interpolationFactor
  };
};